import phoneImage from "../asset/Images/phone.png";

const ContactHero = () => {
  return (
    <section className="bg-gradient-to-r from-pink-300 via-purple-400 to-purple-500 pt-24 pb-6 md:pt-28 md:pb-8">
      <div className="w-full max-w-full mx-auto px-4 sm:px-6 md:px-15 lg:px-20 xl:px-6">
        <div className="flex flex-row items-center justify-center gap-2">
          <h1 className="text-4xl md:text-7xl lg:text-[8rem] font-bold text-white">
            Contact Us
          </h1>


          <img
            src={phoneImage}
            alt="Retro Phone"
            className="w-20 md:w-28 lg:w-28 object-contain -rotate-6 -ml-4 -mt-10 z-10 relative transform -translate-y-4"
          />

        </div>
      </div>
    </section>
  );
};

export default ContactHero;